<template>
    <div class="form">
        <!-- capacity -->
        <div class="form__section">
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrSlider
                        label="Leistung"
                        label-class="form__title"
                        :rangeValueTemplate="'%{0} bis %{1} kW'"
                        :value="data.capacity"
                        :show-tooltip="false"
                        :options="sliderOptions"
                        :range="true"
                        @change="fieldChangeHandler($event, 'capacity')"
                    />
                </div>
            </div>
        </div>
        <!-- Plug Types -->
        <div class="form__section">
            <div class="form__title">Steckertypen</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrChoiceGroup 
                        :values="data.plugTypes" 
                        :options="plugOptions"
                        :output-array="true"
                        :tracking-data-category="'Charging Stations'"
                        :min-amount="1"
                        :specialIconType="'plugIcon'"
                        @change="fieldChangeHandler($event, 'plugTypes')"
                    />
                </div>
            </div>
        </div>

        <!-- Other options -->
        <div class="form__section">
            <div class="form__title">Weitere Filteroptionen</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrChoiceGroup 
                        :values="data.other" 
                        :options="otherOptions"
                        @change="fieldChangeHandler($event, 'other')"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import settingsTabBlueprint from '@/mixins/settings-tab-blueprint';
import SmrChoiceGroup from '@/components/form/SmrChoiceGroup.vue'
import { getPoiConfig } from '@/utils/poi-data/poi-config'
import SmrSlider from '@/components/form/SmrSlider.vue'

export default {
    components: {
        SmrChoiceGroup,
        SmrSlider,
    },
    mixins: [
        settingsTabBlueprint
    ],
    data() {
        return {
            data: {},
            plugOptions: getPoiConfig(this.optionsId).plugs,
            sliderOptions: [
                {
                    value: 0,
                    label: '0',
                },
                {
                    value: 22,
                    label: '22',
                },
                {
                    value: 50,
                    label: '50',
                },
                {
                    value: 100,
                    label: '100',
                },
                {
                    value: 150,
                    label: '150',
                },
                {
                    value: 500,
                    label: '350+',
                },
            ],
            trackingData: {
                category: 'Charging Stations',
                action: 'Settings'
            },
        }
    },
    computed: {
        ...mapGetters(['user', 'mobile']),
        otherOptions() {
            return [
                {value: 'openNextHour',label: 'In der nächsten Stunde geöffnet'},
                {value: 'openAllDay', label: '24 h geöffnet'},
                {value: 'oeamtcEPower', label: 'Nur ÖAMTC ePower Ladestationen'},
                {value: 'free', label: 'Nur Kostenlose'},
                {value: 'greenEnergy', label: 'Nur 100% Ökostrom'},
                {value: 'favouritesOnly', label: 'Nur Favoriten', disabled: this.user ? false : true},
            ]
        }
    }
}
</script>
